import React, { ReactNode, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import ErrorOrYesModal from '@components/common/errorModal/ErrorOrYesModal';
import errorOrYesModalState from '../../recoil/errorOrYesModal/atom';
import navActive from '../../recoil/navActive/atom';
import OwnerGuideTour from '@components/demo/OwnerGuideTour';
interface Props {
  children: ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const errorState = useRecoilValue(errorOrYesModalState);
  // const navStateValue = useRecoilValue(navActive);
  const [navActiveState, setNavActiveState] = useRecoilState(navActive);

  return (
    <>
      <div id="layout">
        {children}
        <OwnerGuideTour />
        {errorState.status && (
          <ErrorOrYesModal
            status={errorState.status}
            title={errorState.title}
            text={errorState.text}
            modalBG={true}
            imgType={errorState.imgType}
            yesCallBack={errorState.yesCallBack}
          />
        )}
      </div>
    </>
  );
};

export default Layout;
